/**
 * Room Object
 * @param {*} fields
 */
export function Room({building_id, room_id, room_name, floor, nano_id}) {
  this.roomId = room_id;
  this.floor = floor;
  this.roomName = room_name;
  this.buildingId = building_id;
  this.nanoId = nano_id;
}
